/* Éloence — Urgency Strip client logic
 * Two responsibilities:
 *  1. Delivery-mode: countdown timer + {time_left} + {date} substitution.
 *  2. Stock-mode: re-fetch via Section Rendering API on variant change.
 */
(function () {
  'use strict';

  function initCountdowns() {
    document.querySelectorAll('[data-el-urgency][data-mode="delivery"]').forEach((el) => {
      const target = resolveTarget(el);
      if (!target) return;
      const template = el.dataset.template || '';
      const textEl = el.querySelector('[data-el-urgency-text]');
      const delivery = resolveDelivery(el);
      if (!textEl) return;

      function tick() {
        const now = Date.now();
        let diff = target.getTime() - now;
        if (diff <= 0) {
          if (el.dataset.submode === 'fixed') { el.hidden = true; return; }
          // recurring: roll to tomorrow's cutoff on client for visual continuity
          target.setDate(target.getDate() + 1);
          diff = target.getTime() - now;
        }
        const hours = Math.floor(diff / 3_600_000);
        const mins  = Math.floor((diff % 3_600_000) / 60_000);
        const secs  = Math.floor((diff % 60_000) / 1000);
        const pad   = (n) => String(n).padStart(2, '0');
        const timeLeft = `${hours}h ${pad(mins)}m ${pad(secs)}s`;
        textEl.innerText = template
          .replace('{time_left}', timeLeft)
          .replace('{date}', delivery);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function resolveTarget(el) {
    if (el.dataset.submode === 'fixed') {
      const iso = el.dataset.cutoffIso;
      if (!iso) return null;
      return new Date(iso.replace(' ', 'T'));
    }
    // recurring: today at cutoffTime in merchant tz — approximate with local tz (client-side drift acceptable for MVP)
    const [hh, mm] = (el.dataset.cutoffTime || '14:00').split(':').map(Number);
    const d = new Date();
    d.setHours(hh, mm, 0, 0);
    if (d.getTime() < Date.now()) d.setDate(d.getDate() + 1);
    return d;
  }

  function resolveDelivery(el) {
    if (el.dataset.submode === 'fixed') {
      return formatDate(new Date((el.dataset.deliveryIso || '').replace(' ', 'T')));
    }
    const daysOut = parseInt(el.dataset.daysOut || '3', 10);
    const d = new Date();
    d.setDate(d.getDate() + daysOut);
    return formatDate(d);
  }

  function formatDate(d) {
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  function initVariantRerender() {
    // Listen for the variant change event fired by eloence-pdp-hero's variant selector.
    document.addEventListener('variant:change', async (ev) => {
      const variantId = ev.detail && ev.detail.id;
      if (!variantId) return;
      const hero = document.querySelector('[data-el-pdp-hero]');
      if (!hero) return;
      const sectionId = hero.dataset.sectionId;
      const handle = hero.dataset.productHandle;
      if (!sectionId || !handle) return;
      try {
        const res = await fetch(`/products/${handle}?section_id=${sectionId}&variant=${variantId}`);
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-el-urgency][data-mode="stock"]').forEach((oldEl, i) => {
          const newEl = doc.querySelectorAll('[data-el-urgency][data-mode="stock"]')[i];
          if (newEl) oldEl.replaceWith(newEl);
        });
      } catch (_) { /* silent */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initCountdowns(); initVariantRerender(); });
  } else {
    initCountdowns();
    initVariantRerender();
  }
})();
